import { render, staticRenderFns } from "./VipNyButton.vue?vue&type=template&id=23ddbca0&"
import script from "./VipNyButton.vue?vue&type=script&lang=js&"
export * from "./VipNyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports